import React, { useState, useEffect } from 'react'
import { DataGrid, GridToolbar, gridStringOrNumberComparator } from '@mui/x-data-grid';
import './App.css';


function App() {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL)
      .then((data) => data.json())
      .then((data) => setTableData(data))
  }, []);

  const columns = [
    { field: 'gameName', headerName: 'Name', width: 200,
      renderCell: (params) => {
        return <a href={params.row.url}>{params.row.name}</a>
      },
      valueGetter: (params) => params.row.name,
      sortComparator: (v1, v2, param1, param2) => gridStringOrNumberComparator(v1.name, v2.name, param1, param2)
    },
    { field: 'description', headerName: 'Description/Tags', width: 400 },
    { field: 'storefront', headerName: 'Storefront', width: 150 },
    { field: 'price', headerName: 'Price', width: 100, type: 'number',
      valueFormatter: (params) => {
        if (params.value !== null)
          return `$${params.value}`;
        return params.value;
      }
    }
  ];

  return (
    <div className="App">
      <div style={{ display: 'flex', height: 700 }}>
        <div style={{ flexGrow: 1 }}>
          <DataGrid
            style={{ textAlign: 'left' }}
            rows={tableData}
            columns={columns}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            getRowHeight={() => 'auto'} />
        </div>
      </div>
    </div>
  );
}

export default App;
